import { PLACEMENT } from '@thanx/uikit/popover'
import { Switch } from '@thanx/uikit/switch'
import { Text } from '@thanx/uikit/text'
import PopoverInfo from 'components/PopoverInfo'
import React from 'react'

type Section = {
  title?: string
  content: string | React.ReactNode
  titleClassName?: string
  contentClassName?: string
}

export type Sections = Array<Section>

type BasePropsT = {
  placement?: keyof PLACEMENT
  sections: Sections
  className?: string
}

type PropsT =
  | (BasePropsT & { triggerType?: 'hover'; ariaLabel?: string })
  | (BasePropsT & { triggerType: 'click'; ariaLabel: string })

const PopoverContent: React.FC<PropsT> = props => {
  const { sections, placement, className } = props

  const text = (
    <Text.BodyText5 tag="p" className="mt-m mb-0" color="grey70">
      {sections.map((section, i) => {
        const { title, content, titleClassName, contentClassName } = section
        return (
          <React.Fragment key={i}>
            <Switch condition={!!title}>
              <Text.SmallCaps3
                tag="p"
                bold
                color="inherit"
                className={`${titleClassName || 'mt-s'}`}
              >
                {title}
              </Text.SmallCaps3>
            </Switch>
            <p className={contentClassName}>{content}</p>
          </React.Fragment>
        )
      })}
    </Text.BodyText5>
  )

  if (props.triggerType === 'click') {
    return (
      <PopoverInfo
        placement={placement}
        className={className}
        triggerType={props.triggerType}
        ariaLabel={props.ariaLabel}
        text={text}
      />
    )
  }

  return (
    <PopoverInfo
      placement={placement}
      className={className}
      triggerType={props.triggerType}
      ariaLabel={props.ariaLabel}
      text={text}
    />
  )
}

export default PopoverContent
